module.exports = "/images/karolinska.png?08ae13eedb8d3acd7ca0267091113b29";